export default {
  en: {
    visit_the_page_in_app: 'Visit app',
    attachments: 'Attachments',
    like: 'Like',
    comment: 'Comment',
    attend: {
      title: 'Attending',
    },
    contact: 'Contact',
    done: 'Done',
    snack: {
      generic_error: 'Something went wrong',
    },
    events: {
      participation: 'Participation',
      participants: 'Participants',
      full: 'Booked out',
      details: {
        short: '%{attending} attending',
        long: '%{attending} attending | %{not_attending} not attending',
        short_with_limit: '%{attending}/%{limit} attending',
        long_with_limit:
          '%{attending}/%{limit} attending | %{not_attending} not attending',
      },
      action: {
        attend: 'Accept',
        cannot: 'Decline',
        withdraw: 'Withdraw',
      },
      snack: {
        attend: 'Successfully marked as attending!',
        cannot: 'Successfully marked as not attending!',
        withdraw: 'Successfully withdrew from event!',
      },
    },
    engagement: {
      toggle_true: 'Mark as completed',
      toggle_false: 'Reactivate offer',
    },
    marketplace: {
      toggle_true: 'Mark as sold',
      toggle_false: 'Mark as available',
    },
    kind: {
      offering: 'Offering',
      looking: 'Looking for',
    },
  },
};
